import type { QuotaState } from "./types";

const initialQuotaState: QuotaState = {
    isDataCostVisible: false,
    isDataCreditsModalOpen: false,
    isQuotaContactAdminModalOpen: false,
};

export default initialQuotaState;
